module.exports = __webpack_public_path__ + "img/money-check.791e182f.svg";